const menu = {
    label: 'Tramitações Jurídicas',
    icon: 'pi pi-fw pi-file',
    to: '/solicitacoes/tramitacoes-juridicas',
    matchChildren: true,
    rules: ['TRAMITACOES-JURIDICAS-00'],
};

export default menu;
